// Raw Bistro Foundations — cart counter
(function () {
  var count = 0;
  var countEl = document.querySelector('.rb-cart__count');
  document.querySelectorAll('.rb-product__cta').forEach(function (btn) {
    btn.addEventListener('click', function () {
      count += 1;
      if (countEl) countEl.textContent = String(count);
    });
  });
})();
